var Mn = require('backbone.marionette'),
    Bb = require('backbone');

module.exports = Mn.Behavior.extend({
    onAttach: function () {
        this.build(this.$el);
    },
    onChildviewAttach: function ( view ) {
    },
    build: function ( content ) {
        var header = $( '.menu__section' );
        // header.addClass( 'scrolled' );

        var headerHeight = header.innerHeight();

        $( document ).on( 'scroll', function( event ){
            var scrollPos = $( document ).scrollTop();

            if ( scrollPos > headerHeight ) {
                header.addClass( 'scrolled' );
            } else {
                header.removeClass( 'scrolled' );
            }
        } );

        $(window).click(function() {
            var $menu = $('.menu__dropdown');

            $('.menu__list').stop().slideUp(300, function() {
                $menu.removeClass('open');
            });
        });

        $( content ).on('click', '.menu__hamburger', function( event ){
            event.stopPropagation();

            var $menu = $('.menu__dropdown');

            if ($menu.hasClass('open')) {
                $('.menu__list').stop().slideUp(300, function() {
                    $menu.removeClass('open');
                });
            } else {
                $menu.addClass('open');
                $('.menu__list').stop().slideDown(300);
            }
        } );

        if(window.matchMedia("(max-width:768px)").matches){
            $('.carrer_center').prop('target', '_blank');
        }else{
            $('.carrer_center').removeProp('target');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./resources/assets/site/scripts/behaviors/Menu.js
// module id = 42
// module chunks = 3 14